import LegalShell from "@/pages/LegalShell";

export default function Refund() {
  return (
    <LegalShell title="Refund & Cancellation Policy" effective="1 February 2026">
      <p>
        <strong>RIF Master</strong> is a one-time payment digital product providing lifetime access to a clinical
        decision-support workflow. This page explains when refunds and cancellations are available.
      </p>

      <h2>1. What you're paying for</h2>
      <p>
        A single payment of <strong>₹4,999 (INR)</strong> unlocks full lifetime access for one clinician: the
        interactive 5-step RIF workflow, PDF export, patient case history, research library and future updates.
      </p>

      <h2>2. Cancellation</h2>
      <p>
        There is no recurring subscription — <strong>nothing renews and nothing needs to be cancelled</strong>. You
        can stop using the Service at any time; no further charges will ever be made.
      </p>

      <h2>3. Refund eligibility</h2>
      <p>
        Because the Service is a digital product with immediate access, we offer refunds only in the following cases:
      </p>
      <ul>
        <li><strong>Duplicate payment</strong> — if you were charged twice for the same account, we will refund the
          duplicate transaction in full within 5–7 working days of report.</li>
        <li><strong>Payment succeeded but access was not activated</strong> — if your Razorpay transaction is
          confirmed but your account remains locked 24 hours after payment, we will either activate the account or
          refund the transaction in full at your election.</li>
        <li><strong>Documented service outage</strong> — sustained inability to use core Service features for more
          than 14 consecutive days and not resolved after written notice may, at the Owner's discretion, entitle
          you to a partial or full refund.</li>
      </ul>

      <h2>4. What is not refundable</h2>
      <ul>
        <li>Change of mind after payment.</li>
        <li>Inability to use the Service due to lack of internet access, incompatible hardware or software on your side.</li>
        <li>Dissatisfaction with a clinical outcome — the Service is decision-support material only and does not
          guarantee any patient outcome.</li>
        <li>Payments processed more than 30 days before the refund request (subject to the exceptions above).</li>
      </ul>

      <h2>5. How to request a refund</h2>
      <p>
        Email <a href="mailto:drmonashroff@gmail.com">drmonashroff@gmail.com</a> from the address you registered with,
        including:
      </p>
      <ul>
        <li>Your registered email</li>
        <li>The Razorpay payment ID or UPI transaction reference (UTR)</li>
        <li>A short description of the issue</li>
      </ul>
      <p>
        We acknowledge refund requests within 2 working days and typically complete approved refunds within
        <strong> 5–7 working days</strong> via the original payment method through Razorpay.
      </p>

      <h2>6. Chargebacks</h2>
      <p>
        If you have a concern about a payment, please contact us first — we are always able to resolve it faster than
        a bank-side chargeback. Fraudulent chargebacks will result in immediate suspension of Service access.
      </p>

      <h2>7. Contact</h2>
      <p>
        Any question about this policy: <a href="mailto:drmonashroff@gmail.com">drmonashroff@gmail.com</a>.
      </p>
    </LegalShell>
  );
}
